import { S3_URL, USER_TYPES } from 'constants/index';
import { IMAGE_PATHS } from 'constants/imagePaths';
import useTranslate from 'hooks/useTranslate';
import React from 'react';
import { Button, Col, Image, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const CompanyFollowers: React.FC<any> = ({ FollowingsCompanyData, unFollowCompany }) => {
	const navigate = useNavigate();
	const { translate } = useTranslate();
	return (
		<>
			{FollowingsCompanyData?.length > 0 ? (
				FollowingsCompanyData?.map((res: any, index: any) => (
					<Col key={`${res?.name}-${res?.userId}-${index}-follow`} xxl={4} xl={6}>
						<Stack className="connections-box gap-3">
							<div className="d-flex gap-3">
								<div className="connections-box-profile position-relative">
									<Image
										src={`${S3_URL}${res?.profilePicture}`}
										onError={({ currentTarget }) => {
											currentTarget.onerror = null;
											currentTarget.src =
												res?.userType === USER_TYPES.COMPANY
													? IMAGE_PATHS.JobLogo1
													: IMAGE_PATHS.UserDefault;
										}}
										onClick={() => {
											navigate(`/${res?.userType}/profile/${res?.userId}`);
										}}
										alt="logo"
										className="w-100 h-100"
										loading="lazy"
									/>
								</div>
								<Stack className="gap-2 flex-1">
									<h6
										className="fw-bold mb-0"
										onClick={() => {
											navigate(`/${res?.userType}/profile/${res?.userId}`);
										}}
									>
										{res?.name}
									</h6>
									<p className="mb-0">
										{res?.userType === 'seeker' ? res?.description : res?.address}{' '}
									</p>
									{unFollowCompany && (
										<div className="d-flex gap-2 mt-auto">
											<Button
												onClick={() => unFollowCompany(res?.userId)}
												className="gray-transparent-btn rounded-pill lh-1"
											>
												{translate('Common.unFollow')}
											</Button>
										</div>
									)}
								</Stack>
							</div>
						</Stack>
					</Col>
				))
			) : (
				<Col>
					<Stack className="posted-job-box">
						<p className="mb-0">{translate('Common.noCompanyFound')} </p>
					</Stack>
				</Col>
			)}
		</>
	);
};

export default CompanyFollowers;
